import { InjectionToken } from '@angular/core';

import { ToastPosition, ToastVariant } from './toast.component';

export interface ToastConfig {
  maxCount: number;
  defaultDuration: number;
  defaultPosition: ToastPosition;
  defaultVariant: ToastVariant;
  autoClose: boolean;
}

export const TOAST_CONFIG = new InjectionToken<ToastConfig>('TOAST_CONFIG', {
  providedIn: 'root',
  factory: (): ToastConfig => ({
    maxCount: 5,
    defaultDuration: 4000,
    defaultPosition: 'top-center',
    defaultVariant: 'warning',
    autoClose: true
  })
});
